import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/styles": { useTheme }, "@mui/material/MobileStepper": MobileStepper, "@mui/material/Paper": Paper, "@mui/material/Typography": Typography, "@mui/material/Button": Button, "@mui/icons-material/KeyboardArrowLeft": KeyboardArrowLeft, "@mui/icons-material/KeyboardArrowRight": KeyboardArrowRight } } });
export default ClientProvider;
